import DemoContent from '../components/DemoPageContent/DemoContent';
import CopyRight from '../components/Footer/CopyRight';

const DemoPage = function () {
  return (
    <>
      <DemoContent />

      <CopyRight />
    </>
  );
};

export default DemoPage;
